var map = {
	".": "fdd6",
	"./": "fdd6",
	"./index": "fdd6",
	"./index.js": "fdd6",
	"./user": "1598",
	"./user/": "1598",
	"./user/index": "1598",
	"./user/index.js": "1598"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cf08";